import React from "react";
import { Card, ListGroup, ProgressBar, Spinner } from "react-bootstrap";
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaExclamationCircle,
} from "react-icons/fa";
import { DeliveryDashboardServices } from "../DeliveryDashboardServices";

// Devuelve { icon, diff } según planned vs real
const getIndicator = (planned, real) => {
  const diff = real - planned; // positivo si real adelantado
  const absDiff = Math.abs(diff).toFixed(2);

  if (diff >= 0) {
    return { icon: <FaCheckCircle color="#28a745" />, diff, status: "Al día" };
  }
  if (absDiff <= 10) {
    return {
      icon: <FaExclamationTriangle color="#FFC107" />,
      diff,
      status: "Desv. Moderada",
    };
  }
  return {
    icon: <FaExclamationCircle color="#DC3545" />,
    diff,
    status: "Desv. Crítica",
  };
};

const HealthStatusCard = ({ title, projects, img, styles,loading }) => {
  return (
    <Card className={`h-100 ${styles.boxShadow}`}>
      <Card.Header className={styles.CardHeader}>
        {img}
        <span className={styles.title}>{title}</span>
      </Card.Header>
      { loading? 
      <div className="d-flex mt-5 align-items-center flex-column">
        <Spinner animation="border" role="status"></Spinner>
        <span className="visually-hidden">Cargando Proyectos Estratégicos...</span>
      </div>
      :
      <ListGroup variant="flush" className="">
        {projects?.map((p) => {
          const planned = p.PctPlaneadoProyecto;
          const real = p.PctCompletadoProyecto;
          const { icon, diff, status } = getIndicator(planned, real);
          const absDiff = Math.abs(diff).toFixed(2);

          return (
            <ListGroup.Item key={p.Nombre} className={styles.item}>
              <div
                className="d-flex justify-content-between mb-2"
                title={p.Nombre}
              >
                <strong className={`mr-3 mb-2 ${styles.projectName}`}>
                  {p.Cliente} - {p.CODProyecto}
                </strong>
                <small className={styles.projectPct}>
                  <div className={styles.diffRow}>
                    {icon}
                    <span className={styles.diffText}>
                      {diff >= 0 ? `${absDiff}%` : `-${absDiff}%`}
                    </span>
                  </div>
                </small>
              </div>

              {/* Barra PLANEADO */}
              <div className={styles.barRow}>
                <span className={styles.barLabel}>Planeado</span>
                <ProgressBar
                  now={planned}
                  max={100}
                  variant="info"
                  label={`${planned}%`}
                  style={{ flex: 1,height:"12px" }}
                  className={styles.progressBar}
                />
              </div>

              {/* Barra REAL */}
              <div className={styles.barRow}>
                <span className={styles.barLabel}>Real</span>
                <ProgressBar
                  now={real}
                  max={100}
                  variant="success"
                  label={`${real}%`}
                  style={{ flex: 1,height:"12px" }}
                  className={styles.progressBar}
                />
              </div>
              <div>
                <div className="text-left mt-3">
                  <i className="fa fa-dollar-sign mr-2"></i>
                  <span className="h6 mt-3">Presupuesto Estimado</span>
                </div>
                <h6 className="mt-2">
                  $ {DeliveryDashboardServices.formatCurrency(p.CostoPlaneado)} COP
                </h6>
              </div>
            </ListGroup.Item>
          );
        })}
      </ListGroup>
      }
    </Card>
  );
};

export default HealthStatusCard;
